import React from "react";
import DefaultRow from "./rowRenderers/DefaultRow";
import DataTypeHelper from "./dataTypes/DataTypeHelper";
import RevisionHistoryRow from "./rowRenderers/RevisionHistoryRow";
import HousekeepingStaffRoomsRow from "./rowRenderers/HousekeepingStaffRoomsRow";
import ButtonHelper from "./buttons/ButtonHelper";
import DataTableSearch from "./DataTableSearch";
import Cookies from "js-cookie";
import numeral from "numeral";

class DataTable extends React.Component {
  constructor(props) {
    super(props);

    var order_by = localStorage.getItem(props.endpoint + "|order_by");

    // ✅ FIX: remove invalid sort keys like 'automatic_price_rules'
    if (order_by && order_by.includes("automatic_price_rules")) {
      localStorage.removeItem(props.endpoint + "|order_by");
      order_by = null;
    }
    
    if (order_by && typeof order_by.replace === "function") {
      order_by = order_by.replace(/_translations/g, 's');
    }

    this.state = {
      data: [],
      headers: [],
      footer_data: [],
      table_actions: [],
      filter_actions: [],
      selected_filter_actions: [],
      toggleCheckboxes: false,
      checkboxesChecked: [],
      loadCount: 0,
      loading: false,
      order_by: order_by && order_by != "null" ? order_by : null,
      page: isNaN(this.props.page) ? 1 : this.props.page,
      read_only: this.props.read_only || false,
      results_per_page: isNaN(this.props.results_per_page)
        ? Cookies.get("results_per_page") || 10
        : this.props.results_per_page,
      total_count: 0,
      total_pages: 0,
      header_lengths: null,
      showSearch: false,
      searchValues: {},
      disabled_ids: null,
      showTrash: this.props.show_trash || null,
      showItems: this.props.show_items || null,
      allowRefresh: this.props.allow_refresh || null,
      archiveEndpoint: this.props.archive_endpoint || null,
      archiveReturnLink: this.props.archive_return_link || null,
      exportCSVEndpoint: this.props.export_csv_endpoint || null,
      settingLinkText: this.props.setting_link_text || null,
      showArchived: this.props.show_archived || null,
      showSystemData: this.props.show_system_data || null,
      modelName: this.props.model_name || null,
      housekeeping_view: this.props.housekeeping_view || null,
    };
    this.updateCheckboxesChecked = this.updateCheckboxesChecked.bind(this);
    this.onChangeResultsPerPage = this.onChangeResultsPerPage.bind(this);
    this.toggleCheckboxes = this.toggleCheckboxes.bind(this);
    this.sortColumn = this.sortColumn.bind(this);
    this.refresh = this.refresh.bind(this);
    this.bindPopovers = this.bindPopovers.bind(this);
    this.gotoNextPage = this.gotoNextPage.bind(this);
    this.gotoPrevPage = this.gotoPrevPage.bind(this);
    this.search = this.search.bind(this);
    this.changeSearchValues = this.changeSearchValues.bind(this);
    this.isArray = this.isArray.bind(this);
    this.loadData = this.loadData.bind(this);
    this.onChangeSelectedFilterActions =
      this.onChangeSelectedFilterActions.bind(this);
    this.onChangeLoadingSpinner = this.onChangeLoadingSpinner.bind(this);
  }

  /********************
   * Lifecycle Methods *
   *********************/

  componentDidMount() {
    var self = this;
    this.loadData({mount: true});

    $(window).on("refresh_data_table.datatable", function () {
      self.loadData({mount: true});
    });
  }

  componentWillUnmount() {
    $(window).off("refresh_data_table.datatable");
    $(window).off("resize.datatable");
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props != nextProps || nextState != this.state) {
      return true;
    } else {
      return false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.bindPopovers();
    if (
      prevProps.endpoint != this.props.endpoint ||
      this.props.audit_date != prevProps.audit_date ||
      (this.state.results_per_page != prevState.results_per_page &&
        prevState.results_per_page != "undefined" &&
        prevState.results_per_page != null) ||
      (this.state.order_by != prevState.order_by &&
        prevState.order_by != "undefined" &&
        prevState.order_by != null) ||
      prevState.page != this.state.page ||
      (Object.keys(prevState.searchValues).length === 0 &&
        Object.keys(this.state.searchValues).length > 0 &&
        prevState.headers.length === 0 &&
        this.state.headers.length > 0)
    ) {
      this.loadData();
    } 
    else if (this.props.reLoadData){
      this.loadData();
    }

    if (this.state.checkboxesChecked != prevState.checkboxesChecked) {
      var checkboxesChecked = this.state.checkboxesChecked;

      window.parent.postMessage({
        mceAction: "customAction",
        content: checkboxesChecked.length,
      });
    }

    // broadcast data table update event
    $(window).trigger(`data_table_refresh_${this.props.endpoint}`);
  }

  /*****************
   * Render Methods *
   ******************/

  render() {
    if (
      $(".jumbotron")[0] &&
      $(".jumbotron")[0].children[0].innerHTML != "Loading..."
    ) {
      $(".table-wrapper")[0].style.visibility = "visible";
    }

    return (
      <div
        className={
          "data-table " +
          (this.state.data && this.state.data.length === 0
            ? "data-table-no-data"
            : "")
        }
        ref="container"
      >
        <div className={this.props.tab_data_table ? "card" : null}>
          {this.renderHeader()}
          <div
            className="table-wrapper table-responsive"
            style={
              $(".modal-body")[0]
                ? { visibility: "visible" }
                : { visibility: "visible" }
            }
          >
            <table className="table ">
              {this.renderTableHead()}
              {this.renderTableBody()}
              {this.state.data && this.state.data.length > 0
                ? this.renderFooter()
                : null}
            </table>
          </div>
          {this.state.loading ? (
            <div className="loadingOverlay">
              <div className="spinner"></div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  renderActions() {
    var self = this;

    if (this.state.table_actions && this.state.table_actions.length > 0) {
      // build button helper function
      var checkedCheckboxIds = this.state.checkboxesChecked.join(",");
      var mergedProps = $.extend({}, self.props, self.state);
      mergedProps["checkedCheckboxIds"] = checkedCheckboxIds;
      mergedProps["onChangeSelectedFilterActions"] =
        this.onChangeSelectedFilterActions;
      mergedProps["onChangeLoadingSpinner"] = this.onChangeLoadingSpinner;
      // how many button groups?
      if (this.isArray(this.state.table_actions[0])) {
        // multiple arrays of actions
        var idx = 0;
        var button_groups = this.state.table_actions.map(
          (table_action_array, tableActionsIdx) => {
            
            var buttons = table_action_array.map((table_action) => {
              if (table_action) {
                // Extract action_params from table_action and add to mergedProps
                var buttonProps = $.extend({}, mergedProps);
                if (table_action.action_params) {
                  buttonProps["action_params"] = table_action.action_params;
                }
                
                return ButtonHelper.renderButton(
                  table_action.button_type || "Default",
                  table_action,
                  buttonProps
                );
              }
            });
            idx = idx + 1;
            return (
              <div
                key={idx}
                className={`btn-group action-group button-group-${
                  this.state.table_actions.length - tableActionsIdx
                }`}
                role="group"
              >
                {buttons}
              </div>
            );
          }
        );

        if (this.state.filter_actions && this.state.filter_actions.length > 0) {
          var button = ButtonHelper.renderButton(
            "Filter",
            this.state.filter_actions,
            mergedProps
          );
          button_groups.push(
            <div
              key={(idx += 1)}
              className="btn-group action-group"
              role="group"
            >
              {button}
            </div>
          );
        }

        return (
          <div
            className={
              this.props.inModal
                ? "clear-padding data-table-actions col-md"
                : "data-table-actions col-md"
            }
          >
            {button_groups}
          </div>
        );
      } else {
        // single array of actions
        var buttons = this.state.table_actions.map(function (table_action) {
          if (table_action) {
            return ButtonHelper.renderButton(
              table_action.button_type || "Default",
              table_action,
              mergedProps
            );
          }
        });

        return (
          <div
            className={
              this.props.inModal
                ? "clear-padding data-table-actions col-md-6"
                : "data-table-actions col-md-6"
            }
          >
            <div className="btn-group" role="group">
              {buttons}
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }

  search(general) {
    var searchParams = {
      columns: {},
      searchValues: "",
    };

    var searchValues = { ...this.state.searchValues };
    var search_value = [];

    if (general) {
      searchParams.columns.general = searchValues.general;
      this.state.headers.map((header) => {
        if (["String", "User", "Room", "Customer", "Boolean"].includes(header.search_type)) {
          searchParams.columns[header.column_name] = "";
        } else if (header.search_type == "Date" || header.search_type == "Time") {
          searchParams.columns[`${header.column_name}_from`] = "";
        } else if (header.search_type == "Integer") {
          searchParams.columns[`${header.column_name}_equal_to`] = "";
        }

        var header_name = header.display_name || header.column_name;
        if (searchParams.columns.general.includes(I18n.t(`${header_name}`))) {
          var value;
          if (header.search_type == "Date" || header.search_type == "Time") {
            if (searchParams.columns.general.includes(I18n.t(`from`))) {
              value = searchParams.columns.general.split(I18n.t(`${header_name}`) + " " + I18n.t("from") + ": ")[1];

              if (value) {
                value = value.replace(/, \D/g, "|||");
                value = value.split("|||")[0];

                searchParams.columns[`${header.column_name}_from`] = value;
                searchValues[`${header.column_name}_from`] = value;
              }
            }

            if (searchParams.columns.general.includes(I18n.t(`to`))) {
              value = searchParams.columns.general.split(I18n.t(`${header_name}`) + " " + I18n.t("to") + ": ")[1];

              if (value) {
                value = value.replace(/, \D/g, "|||");
                value = value.split("|||")[0];

                searchParams.columns[`${header.column_name}_to`] = value;
                searchValues[`${header.column_name}_to`] = value;
              }
            }
          } else if (["String", "User", "Room", "Customer"].includes(header.search_type)) {
            value = searchParams.columns.general.split(I18n.t(`${header_name}`) + ": ")[1];
            if (value) {
              value = value.replace(/, \D/g, "|||");
              value = value.split("|||")[0];

              searchParams.columns[header.column_name] = value;
              searchValues[header.column_name] = value;
            }
          } else if (header.search_type == "Integer") {
            if (searchParams.columns.general.includes(I18n.t("less_than_or_equal_to"))) {
              value = searchParams.columns.general.split(I18n.t(`${header_name}`) + " " + I18n.t("less_than_or_equal_to") + ": ")[1];
              if (value) {
                value = value.replace(/, \D/g, "|||");
                value = value.split("|||")[0];

                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(value * 100);
                }

                searchParams.columns[`${header.column_name}_less_than_or_equal_to`] = currencyVal || value;
                searchValues[`${header.column_name}_less_than_or_equal_to`] = value;
              }
            } else if (searchParams.columns.general.includes(I18n.t("less_than"))) {
              value = searchParams.columns.general.split(I18n.t(`${header_name}`) + " " + I18n.t("less_than") + ": ")[1];
              if (value) {
                value = value.replace(/, \D/g, "|||");
                value = value.split("|||")[0];

                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(value * 100);
                }

                searchParams.columns[`${header.column_name}_less_than`] = currencyVal || value;
                searchValues[`${header.column_name}_less_than`] = value;
              }
            } else if (searchParams.columns.general.includes(I18n.t("greater_than_or_equal_to"))) {
              value = searchParams.columns.general.split(I18n.t(`${header_name}`) + " " + I18n.t("greater_than_or_equal_to") + ": ")[1];
              if (value) {
                value = value.replace(/, \D/g, "|||");
                value = value.split("|||")[0];

                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(value * 100);
                }

                searchParams.columns[`${header.column_name}_greater_than_or_equal_to`] = currencyVal || value;
                searchValues[`${header.column_name}_greater_than_or_equal_to`] = value;
              }
            } else if (searchParams.columns.general.includes(I18n.t("greater_than"))) {
              value = searchParams.columns.general.split(I18n.t(`${header_name}`) + " " + I18n.t("greater_than") + ": ")[1];
              if (value) {
                value = value.replace(/, \D/g, "|||");
                value = value.split("|||")[0];

                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(value * 100);
                }

                searchParams.columns[`${header.column_name}_greater_than`] = currencyVal || value;
                searchValues[`${header.column_name}_greater_than`] = value;
              }
            } else if (searchParams.columns.general.includes(I18n.t("equal_to"))) {
              value = searchParams.columns.general.split(I18n.t(`${header_name}`) + " " + I18n.t("equal_to") + ": ")[1];
              if (value) {
                value = value.replace(/, \D/g, "|||");
                value = value.split("|||")[0];

                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(value * 100);
                }

                searchParams.columns[`${header.column_name}_equal_to`] = currencyVal || value;
                searchValues[`${header.column_name}_equal_to`] = value;
              }
            }
          } else if (header.search_type == "Boolean") {
            value = searchParams.columns.general.split(I18n.t(`${header_name}`) + ": ")[1];
            if (value) {
              value = value.replace(/, \D/g, "|||");
              value = value.split("|||")[0];

              searchParams.columns[header.column_name] = value;
              searchValues[header.column_name] = value;
            }
          }
        }
      });
    } else {
      this.state.headers.map((header) => {
        var header_name = header.display_name || header.column_name;
        if (header.data_type) {
          if (
            Object.keys(searchValues).some(function (k) {
              return ~k.indexOf(header.column_name);
            })
          ) {
            if (header.options) {
              searchParams.columns[header.column_name] = searchValues[header.column_name];
              var values = "";
              if (typeof searchValues[header.column_name] == "Array") {
                searchValues[header.column_name].map((val, idx) => {
                  if (val != "admin"){
                    if (!I18n.t(val).includes("missing")) {
                      val = I18n.t(val);
                    }
                  }
  
                  if (idx + 1 === searchValues[header.column_name].length) {
                    values += val;
                  } else {
                    values += val + " " + I18n.t("or") + " ";
                  }
                });
                search_value.push(I18n.t(`${header_name}`) + ": " + values);
              } else {
                search_value.push(I18n.t(`${header_name}`) + ": " + searchValues[header.column_name]);
              }
            } else if (header.search_type == "Date" || header.search_type == "Time") {
              if (searchValues[`${header.column_name}_from`]) {
                searchParams.columns[`${header.column_name}_from`] = searchValues[`${header.column_name}_from`];
                search_value.push(I18n.t(`${header_name}`) + " " + I18n.t("from") + ": " + searchValues[`${header.column_name}_from`]);
              }
              if (searchValues[`${header.column_name}_to`]) {
                searchParams.columns[`${header.column_name}_to`] = searchValues[`${header.column_name}_to`];
                search_value.push(I18n.t(`${header_name}`) + " " + I18n.t("to") + ": " + searchValues[`${header.column_name}_to`]);
              }
            } else if (header.search_type == "Integer") {
              if (searchValues[`${header.column_name}_less_than_or_equal_to`]) {
                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(searchValues[`${header.column_name}_less_than_or_equal_to`] * 100);
                }
                
                searchParams.columns[`${header.column_name}_less_than_or_equal_to`] = currencyVal || searchValues[`${header.column_name}_less_than_or_equal_to`];
                search_value.push(I18n.t(`${header_name}`) + " " + I18n.t("less_than_or_equal_to") + ": " + searchValues[`${header.column_name}_less_than_or_equal_to`]);
              } else if (searchValues[`${header.column_name}_less_than`]) {
                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(searchValues[`${header.column_name}_less_than`] * 100);
                }

                searchParams.columns[`${header.column_name}_less_than`] = currencyVal || searchValues[`${header.column_name}_less_than`];
                search_value.push(I18n.t(`${header_name}`) + " " + I18n.t("less_than") + ": " + searchValues[`${header.column_name}_less_than`]);
              } else if (searchValues[`${header.column_name}_greater_than_or_equal_to`]) {
                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(searchValues[`${header.column_name}_greater_than_or_equal_to`] * 100);
                }

                searchParams.columns[`${header.column_name}_greater_than_or_equal_to`] = currencyVal || searchValues[`${header.column_name}_greater_than_or_equal_to`];
                search_value.push(I18n.t(`${header_name}`) + " " + I18n.t("greater_than_or_equal_to") + ": " + searchValues[`${header.column_name}_greater_than_or_equal_to`]);
              } else if (searchValues[`${header.column_name}_greater_than`]) {
                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(searchValues[`${header.column_name}_greater_than`] * 100);
                }

                searchParams.columns[`${header.column_name}_greater_than`] = currencyVal || searchValues[`${header.column_name}_greater_than`];
                search_value.push(I18n.t(`${header_name}`) + " " + I18n.t("greater_than") + ": " + searchValues[`${header.column_name}_greater_than`]);
              } else if (searchValues[`${header.column_name}_equal_to`]) {
                if (header.data_type == "Currency" || header.data_type.includes("AmountMinimumStay")) {
                  var currencyVal = Math.round(searchValues[`${header.column_name}_equal_to`] * 100);
                }

                searchParams.columns[`${header.column_name}_equal_to`] = currencyVal || searchValues[`${header.column_name}_equal_to`];
                search_value.push(I18n.t(`${header_name}`) + " " + I18n.t("equal_to") + ": " + searchValues[`${header.column_name}_equal_to`]);
              }
            } else if (["User", "Customer"].includes(header.search_type)) {
              searchParams.columns[header.column_name] = searchValues[header.column_name] + "|||specific";
              search_value.push(I18n.t(`${header_name}`) + ": " + searchValues[header.column_name]);
            } else if (!["status", "type_of_booking"].includes(header.column_name) && searchValues[header.column_name] && searchValues[header.column_name] != "" && !header.options) {
              searchParams.columns[header.column_name] = searchValues[header.column_name];
              search_value.push(I18n.t(`${header_name}`) + ": " + searchValues[header.column_name]);
            }
          }
        }
      });
    }

    search_value = search_value.join(", ");
    searchValues.general = searchParams.columns.general || search_value;
    searchParams.searchValues = searchValues;

    this.setState({ searchColumns: searchParams.columns });

    return searchParams;
  }

  changeSearchValues(searchValues, loadData, general) {
    var historyState = {
      searchValues: [],
    };

    history.pushState(historyState, "");

    this.setState({ searchValues: searchValues, page: 1 }, () => {
      if (loadData) {
        this.loadData({general: general});
      }
    });
  }

  renderHeader() {
    if (this.props.hideHeaderActions) {
      return null;
    } else {
      const noTableActions = !(
        this.state.table_actions && this.state.table_actions.length
      );
      return (
        <div
          className={
            this.state.data && this.state.data.length === 0
              ? "header no-data-adjustment"
              : "header"
          }
          ref="header"
          style={{backgroundColor: 'inherit'}}
        >
          <div
            className="row flexed actions-and-pagination"
            style={{
              justifyContent: noTableActions ? "flex-end" : "space-between",
              marginRight: noTableActions ? "0px" : "-15px",
            }}
          >
            {this.renderActions()}
            <div
              className={`search-pagination-wrapper ${
                noTableActions ? "" : "col-md-5"
              }`}
            >
              {this.state.allowRefresh
              ?
              this.renderRefreshButton()
              : 
              null}
              {this.state.showSearch ? (
                <DataTableSearch
                  {...this.state}
                  {...this.props}
                  loadData={this.loadData}
                  changeSearchValues={this.changeSearchValues}
                />
              ) : null}
              {!this.props.reservation_segments &&
              this.state.showPagination !== false ? (
                <div
                  className={
                    this.props.tab_data_table ? "controls " : "controls"
                  }
                >
                  {this.renderPagination()}
                  {this.renderSettingsDropdown()}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
  }

  renderNoData() {
    var no_data_text = this.props.no_data_text;

    if (this.state.showSearch) {
      no_data_text = I18n.t("no_search_results");
    }

    return (
      <div className="data-table" ref="container">
        <div className="jumbotron" style={{ marginBottom: 0 }}>
          {this.state.loadCount > 0 || this.props.newRecord ? (
            <div className="text-center" style={{ marginBottom: 0 }}>
              <em>{no_data_text ? no_data_text : I18n.t("no_data")}</em>
            </div>
          ) : (
            <p></p>
          )}
        </div>
      </div>
    );
  }

  renderPagination() {
    // start_record_number
    var start_record_number =
      this.state.page * this.state.results_per_page -
      this.state.results_per_page +
      1;

    if (start_record_number > 0 && this.state.total_count == 0) {
      start_record_number = 0;
    }

    // end_record_number
    var end_record_number = this.state.page * this.state.results_per_page;

    if (
      this.state.total_count <
      this.state.page * this.state.results_per_page
    ) {
      end_record_number = this.state.total_count;
    }

    return (
      <div className="pagination-wrapper">
        <ul className="stats">
          <li>
            <strong>{this.formatNumber(start_record_number)}</strong>–
            <strong>{this.formatNumber(end_record_number)}</strong>{" "}
            {I18n.t("of")}{" "}
            <strong>{this.formatNumber(this.state.total_count)}</strong>
          </li>
        </ul>

        <ul className="pagination">
          <li className="page-arrows">
            <a
              href="#"
              onClick={this.gotoPrevPage}
              className={this.state.page == 1 ? "disabled" : ""}
            >
              <span
                onClick={this.gotoPrevPage}
                className={
                  "ss-left " + (this.state.page == 1 ? " disabled" : "")
                }
              ></span>
            </a>
          </li>
          <li className="page-arrows right-arrow">
            <a
              href="#"
              onClick={this.gotoNextPage}
              className={
                this.state.page >= this.state.total_pages ? "disabled" : ""
              }
            >
              <span
                onClick={this.gotoNextPage}
                className={
                  "ss-right" +
                  (this.state.page >= this.state.total_pages ? " disabled" : "")
                }
              ></span>
            </a>
          </li>
        </ul>
      </div>
    );
  }

  renderResultsPerPage() {
    return (
      <div className="results-per-page">
        <strong>
          <small>{I18n.t("show")}</small>
        </strong>
        <select
          value={this.state.results_per_page}
          onChange={this.onChangeResultsPerPage}
        >
          <option value="10">10 {I18n.t("results")}</option>
          <option value="20">20 {I18n.t("results")}</option>
          <option value="30">30 {I18n.t("results")}</option>
          <option value="50">50 {I18n.t("results")}</option>
        </select>
        <strong>
          <small>{I18n.t("per_page")}</small>
        </strong>
      </div>
    );
  }

  renderSettingsDropdown() {
    var mergedProps = $.extend({}, this.props, this.state);
    mergedProps["onChangeLoadingSpinner"] = this.onChangeLoadingSpinner;
    if (this.props.show_trash == true) {
      return (
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenu1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <span className="ss-settings"></span> &nbsp;
            <span className="caret"></span>
          </button>
          <ul
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdownMenu1"
          >
            <li style={{ textTransform: "uppercase" }}>
              <strong style={{ display: "block", padding: "2px 20px 0 20px" }}>
                <small>{I18n.t("results_per_page")}</small>
              </strong>
            </li>
            <hr />
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 10 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 10)}
                href="#"
              >
                10 {I18n.t("results")}
              </a>
            </li>
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 20 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 20)}
                href="#"
              >
                20 {I18n.t("results")}
              </a>
            </li>
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 30 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 30)}
                href="#"
              >
                30 {I18n.t("results")}
              </a>
            </li>
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 50 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 50)}
                href="#"
              >
                50 {I18n.t("results")}
              </a>
            </li>
            {this.state.showTrash == true && this.state.showItems == true ? (
              <li className="archive-link dropdown-item">
                <a
                  href={this.state.archiveReturnLink}
                  className="trash-link"
                >{`${I18n.t(this.state.settingLinkText)}`}</a>
              </li>
            ) : (
              <li className="archive-link dropdown-item">
                <a href={this.state.archiveEndpoint} className="trash-link">
                  {I18n.t("archive")}
                </a>
              </li>
            )}
            {this.state.showItems != true && this.props.export_csv_endpoint ? (
              <li className="export-csv-link dropdown-item">
                {ButtonHelper.renderButton("ExportCSVButton", "", mergedProps)}
              </li>
            ) : null}
          </ul>
        </div>
      );
    } else {
      return (
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenu1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <span className="ss-settings"></span> &nbsp;
            <span className="caret"></span>
          </button>
          <ul
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdownMenu1"
          >
            <li style={{ textTransform: "uppercase" }}>
              <strong style={{ display: "block", padding: "2px 20px 0 20px" }}>
                <small>{I18n.t("results_per_page")}</small>
              </strong>
            </li>
            <hr />
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 10 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 10)}
                href="#"
              >
                10 {I18n.t("results")}
              </a>
            </li>
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 20 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 20)}
                href="#"
              >
                20 {I18n.t("results")}
              </a>
            </li>
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 30 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 30)}
                href="#"
              >
                30 {I18n.t("results")}
              </a>
            </li>
            <li className="per-page-count dropdown-item">
              <a
                className={
                  this.state.results_per_page == 50 ? "selected" : null
                }
                onClick={this.onChangeResultsPerPage.bind(this, 50)}
                href="#"
              >
                50 {I18n.t("results")}
              </a>
            </li>
            <hr />
            {this.props.export_csv_endpoint ? (
              <li className="export-csv-link dropdown-item">
                {ButtonHelper.renderButton("ExportCSVButton", "", mergedProps)}
              </li>
            ) : null}
          </ul>
        </div>
      );
    }
  }

  renderRefreshButton() {
    return (
      <div className="refreshBox">
        <button className="refresh" type="button" onClick={() => this.loadData()}>
          <i className="ss-refresh refresh-icon"></i>
        </button>
      </div>
    )
  }

  renderTableBody() {
    var self = this;

    if (this.state.data && this.state.data.length === 0) {
      return (
        <tbody ref="tbody">
          <tr>
            <td>{this.renderNoData()}</td>
          </tr>
        </tbody>
      );
    }

    var RowRendererComponents = {
      Default: DefaultRow,
      RevisionHistory: RevisionHistoryRow,
      HousekeepingStaffRooms: HousekeepingStaffRoomsRow,
    };

    var rows = this.state.data.map(function (row, i) {
      var RowRendererComponent =
        RowRendererComponents[
          row.renderer in RowRendererComponents ? row.renderer : "Default"
        ];

      return (
        <RowRendererComponent
          {...self.props}
          scheduled_at={self.state.scheduled_at}
          table_actions={self.state.table_actions}
          onToggleCheckbox={self.updateCheckboxesChecked}
          checked={$.inArray(row.id, self.state.checkboxesChecked) !== -1}
          header_lengths={self.state.header_lengths}
          row={row}
          headers={self.state.headers}
          key={self.getRowId(row)}
        />
      );
    });
    return <tbody ref="tbody">{rows}</tbody>;
  }

  getRowId(row) {
    if(!row.id) {
      return this.generateId()
    } else if (typeof row.id !== "undefined" ) {
      return row.id
    } else {
      return JSON.stringify(row.id_fields)
    }
  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return "-" + text;
  }

  renderTableHead() {
    if (!this.state.order_by) {
      return null;
    }

    if (
      this.state.checkboxesChecked.length !== this.state.data.length &&
      this.state.checkboxesChecked.length !== 0
    ) {
      $(this.refs.selectAll).prop("indeterminate", true);
    }

    var self = this;
    var sort = this.state.order_by.split(" ");
    var multiple_allowed = this.multipleAllowed();

    if (this.state.data && this.state.data.length === 0) {
      var columns = [];
    } else {
      var columns = this.state.headers.map(function (header) {
        if (header.sort !== false) {
          // default - sort is enabled
          return (
            <th
              id={header.column_name}
              key={header.column_name}
              scope="col"
              className={`${
                header.display_name || header.column_name
              }-header table-head ${
                header.data_type
              }-header ${self.renderTextAlign(header.text_align)}`}
            >
              <a
                href="#"
                onClick={self.sortColumn}
                data-name={header.column_name}
                className={self.renderSortClassName(
                  header.column_name,
                  sort[0],
                  sort[1]
                )}
              >
                {I18n.t(header.display_name || header.column_name)}
              </a>
            </th>
          );
        } else {
          // no sort
          return (
            <th
              id={header.column_name}
              key={header.column_name}
              scope="col"
              className={`${
                header.display_name || header.column_name
              }-header table-head ${header.data_type}-header`}
              style={
                typeof header.text_align != "undefined"
                  ? { textAlign: header.text_align }
                  : {}
              }
            >
              {I18n.t(header.display_name || header.column_name)}
            </th>
          );
        }
      });
    }

    // do we have table actions? (and thus do we need checkboxes?)
    if (this.state.table_actions && this.state.table_actions.length > 0) {
      if (multiple_allowed) {
        columns.unshift(
          <th
            scope="col"
            key="th_checkbox"
            className="header-checkbox col-checkbox"
          >
            <input
              type="checkbox"
              name="toggle_checkboxes"
              ref="selectAll"
              onChange={this.toggleCheckboxes}
              checked={this.state.toggleCheckboxes}
            />
          </th>
        );
      } else {
        columns.unshift(
          <th
            scope="col"
            key="th_checkbox"
            className="header-checkbox col-checkbox"
          >
            &nbsp;
          </th>
        );
      }
    }

    return (
      <thead className="thead">
        <tr>{columns}</tr>
      </thead>
    );
  }

  renderFooter() {
    if (this.state.footer_data) {
      var self = this;

      var footer_columns = [];
      var mergedProps = {
        ...self.props,
        header_lengths: self.state.header_lengths,
        headers: self.state.headers,
      };

      this.state.headers.map((header, idx) => {
        if (footer_columns.length == 0 && this.state.table_actions) {
          footer_columns.unshift(
            <td idx={idx} scope="col" key="checkbox" className="td">
              &nbsp;
            </td>
          );
        }

        if (header.footer_data == true) {
          var data_type = header.footer_data_type
            ? header.footer_data_type
            : header.data_type;
          footer_columns.push(
            <td
              idx={idx}
              className={`${data_type}DataType-td ${
                header.display_name ? header.display_name : header.column_name
              }-td`}
              key={header.column_name}
            >
              {DataTypeHelper.renderColumn(
                data_type,
                self.state.footer_data[header.column_name],
                mergedProps,
                header
              )}
            </td>
          );
        } else {
          footer_columns.push(
            <td idx={idx} scope="col" key={header.column_name} className="td">
              &nbsp;
            </td>
          );
        }
      });

      return (
        <tfoot className="tfoot" style={{ borderTop: "2px double #999" }}>
          <tr>{footer_columns}</tr>
        </tfoot>
      );
    }
  }

  renderSortClassName(column, order_by, direction) {
    if (order_by.indexOf(".") != -1) {
      order_by = order_by.split(".")[1];
    }

    if (order_by.includes(column)) {
      if (direction.indexOf("ASC") == -1) {
        return "desc";
      } else {
        return "asc";
      }
    } else {
      return "";
    }
  }

  renderTextAlign(text_align) {
    if (text_align === "left") {
      return "text-left";
    } else if (text_align === "center") {
      return "text-center";
    } else if (text_align === "right") {
      return "text-right";
    } else {
      return "text-left";
    }
  }

  /**********************
   * DataTable Functions *
   ***********************/

  /**
   * Binds popover functionality to all popover toggle links
   */

  bindPopovers() {
    $('[data-toggle="popover"]')
      .popover({ container: "body", html: true, placement: "auto top" })
      .on("show.bs.popover", function () {
        $('[data-toggle="popover"]').not(this).popover("hide");
      });
  }

  formatNumber(num) {
    return numeral(num).format(
      "0" + I18n.t("number.currency.format.delimiter") + "0"
    );
  }

  gotoNextPage(event) {
    event.preventDefault();
    event.stopPropagation();

    if ($(event.target).hasClass("disabled")) {
      // shhh...
    } else {
      this.setState({ loading: true, page: this.state.page + 1 });
    }
  }

  gotoPrevPage(event) {
    event.preventDefault();
    event.stopPropagation();

    if ($(event.target).hasClass("disabled")) {
      // shhh...
    } else {
      this.setState({ loading: true, page: this.state.page - 1 });
    }
  }

  isArray(obj) {
    return toString.call(obj) === "[object Array]";
  }

  onChangeSelectedFilterActions(selected_filter_actions) {
    this.setState({
      selected_filter_actions: selected_filter_actions,
      loading: true,
    });
  }

  onChangeLoadingSpinner(loading) {
    this.setState({
      loading: loading,
    });
  }

  loadData(opts={}) {
    this.setState({ loading: true });
    if (this.props.ids) {
      var data = {
        ids: this.props.ids,
        order_by: this.state.order_by,
        page: this.state.page,
        filter_actions: this.state.selected_filter_actions,
        read_only: this.state.read_only,
        results_per_page: this.state.results_per_page,
      };
    } else if (this.props.night_audit) {
      var data = {
        order_by: this.state.order_by,
        page: this.state.page,
        read_only: this.state.read_only,
        results_per_page: this.state.results_per_page,
        date: this.props.audit_date,
        postDate: this.props.postDate,
      };
    } else if (this.props.folio_item) {
      var data = {
        order_by: this.state.order_by,
        page: this.state.page,
        filter_actions: this.state.selected_filter_actions,
        read_only: this.state.read_only,
        results_per_page: this.state.results_per_page,
        folio_item: this.props.folio_item,
        reservation_segment_guest_types: this.props
          .reservation_segment_guest_types
          ? this.props.reservation_segment_guest_types
          : null,
        calculate_taxes_and_fees: this.props.calculate_taxes_and_fees,
        item_type: this.props.item_type,
        tax_ids: this.props.tax_ids,
        fee_ids: this.props.fee_ids,
      };
    } else {
      var data = {
        order_by: this.state.order_by,
        page: this.state.page,
        filter_actions: this.state.selected_filter_actions,
        read_only: this.state.read_only,
        results_per_page: this.state.results_per_page,
        showSystemData: this.state.showSystemData,
        showArchived: this.state.showArchived,
        housekeeping_view: this.props.housekeeping_view || null,
        model_name: this.state.modelName,
      };
    }

    var searchParams = {};
    
    searchParams = this.search(opts["general"]);

    var historyState = {
      searchValues: searchParams.searchValues,
    };

    history.pushState(historyState, "");

    data.search_columns = Object.keys(searchParams).length !== 0 ? searchParams.columns : this.state.searchValues;    
  
    if (
      opts["mount"] &&
      history.state &&
      history.state.searchValues &&
      Object.keys(history.state.searchValues).length > 0 &&
      JSON.stringify(history.state.searchValues) !==
        JSON.stringify(this.state.searchValues)
    ) {
      data.search_columns = history.state.searchValues;
    }

    if (this.props.loadDataCallback) {
      this.props.loadDataCallback();
    }
    
    var self = this;
    $.ajax({
      method: "POST",
      url: this.props.endpoint,
      data: data,
    })
      .done((response) => {
        localStorage.setItem(self.props.endpoint + "|order_by", self.state.order_by);

        if (this.props.updateNoteCount && response.total_count) {
          this.props.updateNoteCount(response.total_count);
        }

        if (this.props.itemsAndTotal) {
          this.props.itemsAndTotal(
            response.data,
            response.total,
            response.count,
            response.refunded_total ? response.refunded_total : null
          );
        }

        // update checkboxesChecked - when we get new data, only keep ids that are present in response.data
        var checkboxesChecked = response.checkboxesChecked || [];
        for (
          var i = 0, ilen = self.state.checkboxesChecked.length;
          i < ilen;
          i++
        ) {
          var id = self.state.checkboxesChecked[i];

          for (var j = 0, jlen = response.data.length; j < jlen; j++) {
            if (response.data[j].id == id && !checkboxesChecked.includes(id)) {
              checkboxesChecked.push(id);
            }
          }
        }
        // update state data
        self.setState({
          checkboxesChecked: checkboxesChecked,
          data: response.data,
          table_actions: response.table_actions,
          filter_actions: response.filter_actions,
          headers: response.headers,
          footer_data: response.footer_data,
          loadCount: self.state.loadCount + 1,
          loading: false,
          order_by: response.order_by,
          disabled_ids: response.disabled_ids,
          total_count: response.total_count,
          total_pages: response.total_pages,
          reservation: response.reservation ? response.reservation : null,
          page: response.total_pages === 1 ? 1 : this.state.page,
          searchValues: Object.keys(searchParams).length !== 0 ? searchParams.searchValues : this.state.searchValues,
          showSearch: response.showSearch,
          showPagination: response.showPagination,
        });
        if (response.housekeeping_users) {
          self.setState({ housekeeping_users: response.housekeeping_users });
        }
        if (response.users) {
          self.setState({ users: response.users });
        }
        if (typeof self.props.onLoadDataSuccess == "function") {
          self.props.onLoadDataSuccess(response);
        }
        if (this.state.checkboxesChecked.length == 0) {
          $(this.refs.selectAll).prop("indeterminate", false);
          this.setState({ toggleCheckboxes: false });
        }
      })
      .fail(function (response) {
        self.setState({ loading: false });
      });
  }

  multipleAllowed() {
    // are 'multiple' allowed for any table actions? - if so, add a toggle/untoggle all checkbox
    var multiple_allowed = this.state.allow_multiple;

    if (this.state.table_actions && this.state.table_actions.length > 0) {
      for (var i = 0, ilen = this.state.table_actions.length; i < ilen; i++) {
        for (
          var j = 0, jlen = this.state.table_actions[i].length;
          j < jlen;
          j++
        ) {
          if (
            this.state.table_actions[i][j] &&
            this.state.table_actions[i][j].enabled == "multiple"
          ) {
            multiple_allowed = true;
            break;
          }
        }
      }
    }

    return multiple_allowed;
  }

  onChangeResultsPerPage(num, event) {
    event.preventDefault();

    this.setState({ loading: true, results_per_page: num }, () => {
      Cookies.set('results_per_page', num);
    });
  }

  refresh() {
    this.loadData();
  }

  sortColumn(event) {
    event.preventDefault();

    var sort = this.state.order_by.split(" ");

    this.setState({
      loading: true,
      order_by: event.target.dataset.name + (sort && sort.length >= 2 && sort[1].indexOf("ASC") != -1 ? " DESC" : " ASC"),
    });
  }

  toggleCheckboxes() {
    this.setState({ 
      toggleCheckboxes: !this.state.toggleCheckboxes, 
      checkboxesChecked: this.state.toggleCheckboxes ? [] : this.state.data.map(function (data) { return data.id }) 
    }, () => {
      if (typeof this.props.onCheckBoxChange === "function") {
        this.props.onCheckBoxChange(this.state.checkboxesChecked);
      }
    });
   
    $(this.refs.selectAll).prop("indeterminate", false);
  }

  updateCheckboxesChecked(checked, id) {
    var checkboxesChecked = this.state.checkboxesChecked.slice(0);

    if (!this.multipleAllowed()) {
      checkboxesChecked = [];
    }

    if (checked) {
      checkboxesChecked.push(id);
      if (this.state.checkboxesChecked.length + 1 == this.state.data.length) {
        $(this.refs.selectAll).prop("indeterminate", false);
        this.setState({ toggleCheckboxes: true });
      }
    } else {
      if (this.state.checkboxesChecked.length == this.state.data.length) {
        this.setState({ toggleCheckboxes: false });
      } else if (this.state.checkboxesChecked.length == 1) {
        $(this.refs.selectAll).prop("indeterminate", false);
      }
      checkboxesChecked.splice(checkboxesChecked.indexOf(id), 1);
    }
    this.setState({ checkboxesChecked: checkboxesChecked }, () => {
      if (typeof this.props.onCheckBoxChange === "function") {
        this.props.onCheckBoxChange(checkboxesChecked);
      }
    });
  }
}

export default DataTable;
